import React from 'react'
import { useNavigate } from 'react-router'

import { useUserInformation } from '../module/sconnStudyData/hook'

const REWARD_STARS = [
  { id: 1, left: '9%', top: '9%', size: 10 },
  { id: 2, left: '26%', top: '22%', size: 8 },
  { id: 3, left: '78%', top: '10%', size: 7 },
  { id: 4, left: '88%', top: '34%', size: 9 },
  { id: 5, left: '14%', top: '66%', size: 8 },
  { id: 6, left: '82%', top: '88%', size: 7 },
]

function SconnGiftLogo() {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/img/sconn_gift_logo.png`}
      alt='sconn'
      className='mb-[18px] h-[78px] w-[114px]'
    />
  )
}

function RewardBackgroundStars() {
  return (
    <div aria-hidden='true' className='pointer-events-none absolute inset-0 overflow-hidden'>
      {REWARD_STARS.map((star) => (
        <span
          key={star.id}
          className='absolute text-[#FFF200] drop-shadow-[0_0_6px_rgba(255,242,0,0.32)]'
          style={{
            left: star.left,
            top: star.top,
            fontSize: `${star.size}px`,
          }}
        >
          ★
        </span>
      ))}
    </div>
  )
}

export default function Complete() {
  const navigate = useNavigate()
  const { data: user } = useUserInformation()
  const userName = user?.nickName || '사용자'

  return (
    <div className='relative min-h-full overflow-hidden bg-gradient-to-b from-[#36398F] to-[#5864E0] px-[20px] pb-[34px] pt-[46px] text-white tablet-sm:px-[30px] tablet-sm:pb-[54px] tablet-sm:pt-[64px]'>
      <RewardBackgroundStars />

      <main className='relative z-[1] mx-auto flex w-full max-w-[420px] flex-col items-center text-center'>
        <section className='flex flex-col items-center'>
          <SconnGiftLogo />

          <h1 className='text-[22px] font-bold leading-[1.35] tablet-sm:text-[24px]'>
            선물을 받았어요!
          </h1>
          <p className='mt-[12px] text-[14px] font-normal leading-[1.55] text-white/95 tablet-sm:text-[15px]'>
            {userName}님을 응원하는 마음을 담아,
            <br />
            지금 바로 이용할 수 있는 디지털 콘텐츠 1종을
            <br />
            내 서재에 쏙 넣어드렸어요!
          </p>
        </section>

        <section className='mt-[38px] flex w-full flex-col gap-[10px] tablet-sm:mt-[48px]'>
          <article className='w-full rounded-[8px] bg-[#F6F7FF] px-[20px] py-[24px] text-[#262626] shadow-[0_16px_32px_rgba(25,30,95,0.16)] tablet-sm:px-[24px]'>
            <p className='text-center text-[12px] font-medium text-[#5A65E0]'>
              선물 1. 무료 디지털 콘텐츠
            </p>

            <div className='mt-[24px] flex items-center gap-[18px] text-left'>
              <picture className='block h-[116px] w-[86px] shrink-0 overflow-hidden rounded-[7px] shadow-bookItem'>
                <source
                  srcSet={`${process.env.PUBLIC_URL}/img/update_popup_thumbnail.webp`}
                  type='image/webp'
                />
                <img
                  src={`${process.env.PUBLIC_URL}/img/update_popup_thumbnail.jpg`}
                  alt='만년형 디지털 다이어리'
                  className='h-full w-full object-cover'
                />
              </picture>

              <div className='min-w-0 flex-1'>
                <p className='line-clamp-3 text-[16px] font-semibold leading-[1.45] text-[#262626]'>
                  만년형 디지털 다이어리
                </p>
                <p className='mt-[8px] line-clamp-2 text-[12px] leading-[1.4] text-[#7A7A7A]'>
                  실용적인 학습 데이터와 함께 다시 찾아올게요.
                </p>
                <p className='mt-[10px] text-[12px] font-medium text-[#5A65E0]'>소장</p>
              </div>
            </div>

            <button
              type='button'
              className='mt-[26px] flex h-[40px] w-full items-center justify-center rounded-[22px] border border-[#D3D3D3] bg-white text-[14px] font-medium text-[#4D4D4D]'
              onClick={() => {
                navigate('/my-page')
              }}
            >
              마이페이지 메인으로
            </button>
          </article>
        </section>
      </main>
    </div>
  )
}
